import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { UniqueDepositDocumentNumber } from "src/app/shared/validators/unique-deposit-number";

@Component({
  selector: "app-approve-deposit-dialog",
  templateUrl: "./approve-deposit-dialog.component.html",
  styleUrls: ["./approve-deposit-dialog.component.scss"],
})
export class ApproveDepositDialogComponent implements OnInit {
  form: FormGroup;
  isMaxLengthValid: boolean = true;
  errorText: string = '';

  constructor(
    public dialogRef: MatDialogRef<ApproveDepositDialogComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private documentValidation: UniqueDepositDocumentNumber
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      documentNumber: ["", [Validators.required, Validators.maxLength(7)], [this.documentValidation.isDocumentNumberUnique()]],
    });

    this.form.get('documentNumber')?.valueChanges.subscribe(() => {
      this.checkMaxLength();
    });
  }

  submit() {
    this.form.markAllAsTouched();
    this.form.updateValueAndValidity();

    if (this.form.valid) {
      let documentNumber = this.form.get("documentNumber").value;

      this.dialogRef.close({ data: documentNumber });
    }
  }

  checkMaxLength() {
    const control = this.form.get('documentNumber');
    this.isMaxLengthValid = !(control?.hasError('maxlength'));
    if (!this.isMaxLengthValid) this.errorText = " (máx 7)";
    else this.errorText = '';
  }

  cancel() {
    this.dialogRef.close();
  }
}
